import React, { useEffect } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { StoryblokComponent, useStoryblokState } from 'gatsby-source-storyblok';
import { useBusinessAppState } from '../../../context/business-app-state.context';

const BusinessHeaderWrapper = () => {
  const data = useStaticQuery(graphql`
    query BusinessHeaderStoryQuery {
      storyblokEntry(full_slug: { eq: "business/header" }) {
        content
        full_slug
        internalId
        name
        uuid
      }
    }
  `);
  const story = useStoryblokState(data.storyblokEntry);

  const { hamburgerMenuIsOpen, contactFormIsOpen } = useBusinessAppState();

  // prevent scroll if menu is open
  useEffect(() => {
    const bodyEl = document.querySelector('body');
    if (contactFormIsOpen || hamburgerMenuIsOpen) {
      bodyEl.classList.add('overflow-hidden');
    } else {
      bodyEl.classList.remove('overflow-hidden');
    }
  }, [contactFormIsOpen, hamburgerMenuIsOpen]);

  return story?.content && <StoryblokComponent blok={story.content} />;
};

export default BusinessHeaderWrapper;
